/**
 * Represents the global object in the current environment.
 * It can be either the window, global, self, or this object.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
 * @see https://mariosfakiolas.com/blog/es2020-access-global-object-with-globalthis-across-different-environment/
 */
export default typeof globalThis !== 'undefined'
	? globalThis
	: typeof global !== 'undefined'
		? global
		: typeof window !== 'undefined'
			? window
			: typeof self !== 'undefined'
				? self
				: new Function('return this')();
